import React from "react";
import { Button, Input, Modal, Popover, Space, Table, Tag, notification } from "antd";
import _ from "lodash";

export const searchResult = async (api, token, query, ts, in_warehouse) => {
  const type = ts ? "barcode" : "name";

  const params = new URLSearchParams({
    token,
    [type]: query,
    with_prices: true,
    with_balance: true,
  });

  if (in_warehouse?.id) {
    params.append("in_warehouse", in_warehouse.id);
  }

  const url = `${api}nomenclature/?${params.toString()}`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      console.error(`HTTP error: ${response.status} ${response.statusText}`);
      console.log("Response URL:", response.url);
      const text = await response.text();
      console.error("Raw response:", text.slice(0, 200));
      throw new Error(`HTTP error: ${response.status}`);
    }
    if (response.headers.get("Content-Type")?.includes("application/json")) {
      const body = await response.json();
      console.log("searchResult response:", body);
      return body.result.map((user) => ({
        label: `${user.name}`,
        value: user.id,
      }));
    } else {
      const text = await response.text();
      console.error("Expected JSON, got:", text.slice(0, 200));
      throw new Error("Response is not JSON");
    }
  } catch (error) {
    console.error("searchResult error:", error);
    notification.error({
      message: "Ошибка",
      description: "Не удалось загрузить данные для автодополнения",
    });
    return [];
  }
};

const searchResultByCategory = async (api, token, category, nom_name, in_warehouse) => {
  const params = new URLSearchParams({
    token,
    category: category === null ? "0" : category,
    with_prices: true,
    with_balance: true,
    limit: 100000
  });

  if (in_warehouse?.id) {
    params.append("in_warehouse", in_warehouse.id);
  }

  if (nom_name && nom_name !== "") {
    params.append("name", encodeURIComponent(nom_name));
  }

  const url = `${api}nomenclature/?${params.toString()}`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      console.error(`HTTP error: ${response.status} ${response.statusText}`);
      console.log("Response URL:", response.url);
      const text = await response.text();
      console.error("Raw response:", text.slice(0, 200));
      throw new Error(`HTTP error: ${response.status}`);
    }
    if (response.headers.get("Content-Type")?.includes("application/json")) {
      const body = await response.json();
      console.log("searchResultByCategory response:", body);
      return body.result.map((user) => ({
        name: user.name,
        key: user.id + 9999,
        unit_name: user.unit_name,
        table_id: user.id,
        description_short: user.description_short,
        action: true,
        barcodes: { barcodes: user?.barcodes, type: "child" },
        prices: { prices: user?.prices, type: "child" },
        balances: { balances: user?.balances, type: "child" },
      }));
    } else {
      const text = await response.text();
      console.error("Expected JSON, got:", text.slice(0, 200));
      throw new Error("Response is not JSON");
    }
  } catch (error) {
    console.error("searchResultByCategory error:", error);
    notification.error({
      message: "Ошибка",
      description: "Не удалось загрузить номенклатуру по категории",
    });
    return [];
  }
};

const searchResultCategory = async (api, token, nom_name, in_warehouse) => {
  const params = new URLSearchParams({
    token,
    with_prices: true,
    with_balance: true,
    limit: 100000
  });

  if (in_warehouse?.id) {
    params.append("in_warehouse", in_warehouse.id);
  }

  if (nom_name && nom_name !== "") {
    params.append("name", encodeURIComponent(nom_name));
  }

  const url = `${api}nomenclature/?${params.toString()}`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      console.error(`HTTP error: ${response.status} ${response.statusText}`);
      console.log("Response URL:", response.url);
      const text = await response.text();
      console.error("Raw response:", text.slice(0, 200));
      throw new Error(`HTTP error: ${response.status}`);
    }
    if (response.headers.get("Content-Type")?.includes("application/json")) {
      const body = await response.json();
      console.log("searchResultCategory response:", body);
      return body.result.map((user) => ({
        name: user.name,
        key: user.id + 9999,
        unit_name: user.unit_name,
        table_id: user.id,
        description_short: user.description_short,
        action: true,
        barcodes: { barcodes: user?.barcodes, type: "child" },
        prices: { prices: user?.prices, type: "child" },
        balances: { balances: user?.balances, type: "child" },
      }));
    } else {
      const text = await response.text();
      console.error("Expected JSON, got:", text.slice(0, 200));
      throw new Error("Response is not JSON");
    }
  } catch (error) {
    console.error("searchResultCategory error:", error);
    notification.error({
      message: "Ошибка",
      description: "Не удалось загрузить список номенклатур",
    });
    return [];
  }
};

class NomAutocomplete extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      options: [],
      typeSearch: false,
      isModalOpen: false,
      nomDS: [],
      loading: false,
      nom_name: "",
      expandedRows: [],
      search: "",
      selectedRowKey: this.props.selectedId ? this.props.selectedId + 9999 : null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.debouncedHandler = _.debounce(this.handleChangeSearch.bind(this), 800);

    this.columns = [
      {
        title: "Наименование",
        key: "name",
        dataIndex: "name",
        render: (_, record) => {
          if (record?.nom_count > 0) {
            return `${record?.name} (${record?.nom_count})`;
          } else {
            return `${record?.name}`;
          }
        },
      },
      {
        title: `Цены`,
        key: "prices",
        dataIndex: "prices",
        render: (values) => {
          if (values?.type === "child") {
            if (values?.prices?.length > 0) {
              if (values?.prices?.length < 2) {
                return values?.prices?.map((item) => (
                  <Tag key={item.price_type}>
                    {item?.price_type}: {item?.price}
                  </Tag>
                ));
              } else {
                return (
                  <Space size="small" direction="vertical">
                    <Tag color="green">
                      {values?.prices[0]?.price_type}: {values?.prices[0]?.price}
                    </Tag>
                    <Popover
                      title="Теги"
                      content={values?.prices
                        ?.slice(1)
                        .map((tag) => (
                          <Space size="small" key={tag.price_type}>
                            <Tag color="green">
                              {tag?.price_type}: {tag?.price}
                            </Tag>
                          </Space>
                        ))}
                    >
                      <Tag color="red">+{values?.prices?.length - 1}</Tag>
                    </Popover>
                  </Space>
                );
              }
            }
          }
        },
      },
      {
        title: `Остатки`,
        key: "balances",
        dataIndex: "balances",
        render: (values) => {
          if (values?.type === "child") {
            if (values?.balances?.length > 0) {
              if (values?.balances?.length < 2) {
                return values?.balances?.map((item) => (
                  <Tag key={item.warehouse_name}>
                    {item?.warehouse_name}: {item?.current_amount}
                  </Tag>
                ));
              } else {
                return (
                  <Space size="small" direction="vertical">
                    <Tag color="green">
                      {values?.balances[0]?.warehouse_name}:{" "}
                      {values?.balances[0]?.current_amount}
                    </Tag>
                    <Popover
                      title="Теги"
                      content={values?.balances
                        ?.slice(1)
                        .map((tag) => (
                          <Tag color="green" key={tag.warehouse_name}>
                            {tag?.warehouse_name}: {tag?.current_amount}
                          </Tag>
                        ))}
                    >
                      <Tag color="red">+{values?.balances?.length - 1}</Tag>
                    </Popover>
                  </Space>
                );
              }
            }
          }
        },
      },
      {
        title: "Единица",
        key: "unit_name",
        dataIndex: "unit_name",
      },
      {
        title: "ШК",
        key: "barcodes",
        dataIndex: "barcodes",
        render: (value) => {
          if (value?.type === "child") {
            if (value?.barcodes?.length > 0) {
              if (value?.barcodes?.length < 2) {
                return value?.barcodes?.map((item) =>
                  item ? (
                    <Tag key={item} color="success">
                      {item}
                    </Tag>
                  ) : (
                    <Tag key={item} color="error">
                      нет штрихкода
                    </Tag>
                  )
                );
              } else {
                return (
                  <Space size="small" direction="vertical">
                    <Tag color="green">{value?.barcodes[0]?.toUpperCase()}</Tag>
                    <Popover
                      title="Теги"
                      content={value?.barcodes
                        ?.slice(1)
                        .map((tag) => (
                          <Tag color="green" key={tag}>
                            {tag.toUpperCase()}
                          </Tag>
                        ))}
                    >
                      <Tag color="red">+{value?.barcodes?.length - 1}</Tag>
                    </Popover>
                  </Space>
                );
              }
            } else {
              return <Tag color="error">нет штрихкода</Tag>;
            }
          }
        },
      },
      {
        title: "Действие",
        key: "action",
        dataIndex: "action",
        render: (_, record) => (
          <Button
            type="primary"
            onClick={() => this.handleRowSelect(record)}
          >
            Выбрать
          </Button>
        ),
      },
    ];
  }

  async componentDidMount() {
    await this.handleSearch("");
  }

  handleChangeSearch = async (e) => {
    const value = e.target.value;
    this.handleChange();
    this.setState({ loading: true, nom_name: value });
    try {
      const res = await searchResultCategory(this.props.api, this.props.token, value, this.props.warehouse);
      this.setState({ nomDS: res, loading: false });
    } catch (error) {
      console.error("Error in handleChangeSearch:", error);
      this.setState({ loading: false });
      notification.error({
        message: "Ошибка",
        description: "Не удалось загрузить данные для поиска",
      });
    }
  };

  handleRowExpand(record) {
    this.setState((prevState) => {
      const expandedRows = prevState.expandedRows.includes(record.key)
        ? prevState.expandedRows.filter((key) => key !== record.key)
        : [...prevState.expandedRows, record.key];
      return { expandedRows };
    });
  }

  handleChange = () => {
    this.setState({ expandedRows: [], selectedRowKey: null });
  };

  onInputName = (name) => {
    this.setState({ search: name });
  };

  handleSearch = async (value) => {
    try {
      const option = await searchResult(
        this.props.api,
        this.props.token,
        value,
        this.state.typeSearch,
        this.props.warehouse
      );
      this.setState({ options: option });
    } catch (error) {
      console.error("Error in handleSearch:", error);
      this.setState({ options: [] });
      notification.error({
        message: "Ошибка",
        description: "Не удалось загрузить данные для автодополнения",
      });
    }
  };

  handlePaste = () => {
    this.setState({ typeSearch: true });
  };

  showModal = async () => {
    this.setState({ isModalOpen: true, loading: true, selectedRowKey: null });
    try {
      const res = await searchResultCategory(this.props.api, this.props.token, "", this.props.warehouse);
      this.setState({ nomDS: res, loading: false });
    } catch (error) {
      console.error("Error in showModal:", error);
      this.setState({ loading: false });
      notification.error({
        message: "Ошибка",
        description: "Не удалось загрузить список номенклатур",
      });
    }
  };

  handleRowSelect = (record) => {
    console.log("Attempting to select record:", record);
    if (this.props.onSelect) {
      this.props.onSelect(record.table_id);
      notification.success({
        message: "Выбрано",
        description: `Номенклатура "${record.name}" выбрана`,
      });
    } else {
      console.error("onSelect prop is not provided or is undefined");
    }
    this.setState({ selectedRowKey: record.key, isModalOpen: false });
  };

  handleOk = () => {
    this.setState({ isModalOpen: false });
  };

  handleCancel = () => {
    this.setState({ isModalOpen: false, selectedRowKey: null });
  };

  walk = (collection, item_id) => {
    for (const item of collection) {
      if (item.key === item_id) return item;
      if (item.children) {
        const result = this.walk(item.children, item_id);
        if (result) return result;
      }
    }
    return null;
  };

  render() {
    const rowClassName = (record) => {
      return record.key === this.state.selectedRowKey ? "selected-row" : "";
    };

    return (
      <>
        <Button
          style={
            this.props.buttonIntegrated
              ? { borderRadius: "8px 0 0 8px", width: "100%" }
              : {}
          }
          type="primary"
          onClick={this.showModal}
        >
          Выбрать
        </Button>
        <Modal
          destroyOnClose
          width={1500}
          title="Выбор номенклатуры"
          open={this.state.isModalOpen}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          <Input
            placeholder="Поиск по наименованию..."
            onChange={this.debouncedHandler}
            style={{ marginBottom: 16 }}
          />
          {this.state.nomDS.length === 0 && !this.state.loading && (
            <div style={{ textAlign: "center", padding: 20, color: "#999" }}>
              Номенклатура не найдена. Попробуйте другой поиск.
            </div>
          )}
          <Table
            columns={this.columns}
            loading={this.state.loading}
            dataSource={[...this.state.nomDS]}
            rowClassName={rowClassName}
            onRow={(record) => ({
              onClick: () => this.handleRowSelect(record),
            })}
            expandable={{
              expandedRowKeys: this.state.expandedRows,
              defaultExpandedRowKeys: this.state.expandedRows,
              indentSize: 50,
              onExpand: async (expanded, record) => {
                this.handleRowExpand(record);
                if (expanded && !record.expanded_flag) {
                  this.setState({ loading: true });
                  try {
                    const newData = [...this.state.nomDS];
                    const item = this.walk(newData, record.key);
                    const res = await searchResultByCategory(
                      this.props.api,
                      this.props.token,
                      record.key,
                      this.state.nom_name,
                      this.props.warehouse
                    );
                    item.children = (item.children || []).concat(res);
                    item.expanded_flag = true;
                    this.setState({ nomDS: newData, loading: false });
                  } catch (error) {
                    console.error("Error in onExpand:", error);
                    this.setState({ loading: false });
                    notification.error({
                      message: "Ошибка",
                      description: "Не удалось загрузить дочерние элементы",
                    });
                  }
                }
              },
            }}
          />
          <style>
            {`
              .selected-row {
                background-color: #e6f7ff !important;
                cursor: pointer;
              }
            `}
          </style>
        </Modal>
      </>
    );
  }
}

export default NomAutocomplete;